export default __webpack_public_path__ + "static/media/jones.40af581d.ogg";